import { useNamespaceSelector } from '@omaze/redux';
import classNames from 'classnames';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { OzIcon, ICON_TYPE, ICON_COLOR, ICON_SIZE } from '../Icon/Icon.component';

import { modalDisplayName } from './Modal.qa';
import { createHideModalAction } from './ModalModule/actions/HideModal/HideModal';
import { IModalState } from './ModalModule/Modal.state';
import { selectModalState } from './ModalModule/selectors/SelectModalState/SelectModalState';

export interface IModalProps {
    className?: string;
    'data-testid'?: string;
}

export function OzModal (props: IModalProps): ReactElement | null {
    const {
        className = '',
        'data-testid': dataTestID = '',
    }: IModalProps = props;

    const modalState: IModalState = useNamespaceSelector(selectModalState);
    const dispatch: Dispatch = useDispatch();

    useEffect((): void => {
        if (modalState.onOpenFunction && (typeof modalState.onOpenFunction === 'function')) {
            modalState.onOpenFunction();
        }
    }, [modalState]);

    if (!modalState.modalComponent) {
        return null;
    }

    function handleClose (): void {
        dispatch(createHideModalAction());

        if (modalState.onCloseFunction && (typeof modalState.onCloseFunction === 'function')) {
            modalState.onCloseFunction();
        }
    }

    return (
        <div
            className={classNames(
                'fixed z-10 flex flex-col justify-center items-center m-0 w-full h-full top-0 left-0', {
                    'bg-modalMask': !modalState.hideMask,
                    [className]: !!className,
                })}
            data-testid={dataTestID}
        >
            <div className='relative bg-white rounded-sm shadow-modal max-w-full'>
                <div className='pt-3 pr-3 h-7'>
                    <span onClick={handleClose}>
                        <OzIcon
                            alt="Close"
                            color={ICON_COLOR.DARK}
                            size={ICON_SIZE.MEDIUM}
                            type={ICON_TYPE.OZ_CLOSE}
                            className='h-2 w-2 float-right hover:cursor-pointer'
                        />
                    </span>
                </div>
                <div className='p-3 pt-0'>
                    <modalState.modalComponent handleModalClose={handleClose} />
                </div>
            </div>
        </div>
    );
}

OzModal.displayName = modalDisplayName;
